import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PortalBuilderService } from 'src/app/shared/services/administratior-service/portal-builder.service';
import { CityServicesService } from 'src/app/shared/services/city-services/city-services.service';
import { ConfiguratorService } from 'src/app/shared/services/configurator-service/configurator.service';
import { CustomerService } from 'src/app/shared/services/customer-services/customer.service';
import { StateServicesService } from 'src/app/shared/services/state-services/state-services.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-customer-business-details',
  templateUrl: './customer-business-details.component.html',
})
export class CustomerBusinessDetailsComponent implements OnInit, OnDestroy {
  bussinessDetails = true;
  userId: any = '';
  customerBusinessDetailAndUploadForm!: FormGroup;
  documents: any = [
    {
      documentName: 'PAN',
      heading: 'Preview',
      file: '',
      name: '',
      preview: '',
      type: 'pan',
    },
    {
      documentName: 'Aadhaar',
      heading: 'Preview',
      file: '',
      name: '',
      preview: '',
      type: 'aadhaar',
    },
    {
      documentName: 'Photo',
      heading: 'Preview',
      file: '',
      preview: '',
      name: '',
      type: 'photo',
    },
    {
      documentName: 'CIN / Deed',
      heading: 'Preview',
      file: '',
      name: '',
      preview: '',
      type: 'cin',
    },
  ];

  currentDate = new Date();

  cValue = formatDate(this.currentDate, 'yyyy-MM-dd', 'en-US');

  customerDataObsSubscription!: Subscription;
  customerDataEventObsSubscription!: Subscription;
  schemes: any[] = [];
  pagination = {
    limit: 1000,
    currentPage: 1,
  };
  selectedCity: any;
  cityData: any = [];
  stateData: any = [];
  selectedState: any;
  selectedFiles: any = [];
  resData: any;
  showErrMsgForm: any = true;
  userRole: any;
  roleOnboading: string = '';
  selectedFilesPan: any;
  selectedFileAadhaar: any;
  selectedFilePhoto: any;
  selectedFileCIN: any;
  folderName: any = 'customerDoc';
  docFiles: any = {};
  singleRole: any;
  // selectedFilesData: any[];
  constructor(
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
    private configuratorSchemeService: ConfiguratorService,
    private cityService: CityServicesService,
    private stateService: StateServicesService,
    private readonly userService: UserService,

    private portalBuilderServices: PortalBuilderService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.userRole = this.userService.getUserRole();

    if (this.userRole == 'partner') {
      this.roleOnboading = 'Reseller';
    }
    if (this.userRole == 'admin') {
      this.roleOnboading = 'Partner';
    }
    if (this.userRole == 'reseller') {
      this.roleOnboading = 'Merchant';
    }
    this.getStateData();
    this.customerDataObsSubscription = this.customerService
      .getCustomerDataObservable()
      .subscribe((res) => {
        console.log('custommer Data', res);
        this.resData = res;
        this.singleRole=res?.role?.type
        this.userId = res._id;
        console.log(this.userId);
        this.patchCustomerBusinessDetailsData(res);
      });
    this.customerDataEventObsSubscription = this.customerService
      .getCustomerFormDataEventObsevable()
      .subscribe((res) => {
        console.log(res);
        let formData = this.customerBusinessDetailAndUploadForm.value;
        let payload: any = {};
        payload.businessCity = this.selectedCity
          ? this.selectedCity
          : this.resData?.businessConfig?.city;
        payload.businessState = this.selectedState
          ? this.selectedState
          : this.resData?.businessConfig?.state;
        payload.businessAddress = formData.address;
        payload.businessPostalCode = formData.postalCode;
        payload.fileData =  this.docFiles;
        payload.organisationType = formData.organisationType
          ? formData.organisationType
          : this.resData?.businessConfig?.organisationType;
        payload.businessName = formData.businessName
          ? formData.businessName
          : this.resData?.businessConfig?.businessName;
        payload.website = formData.website
          ? formData.website
          : this.resData?.businessConfig?.website;
        payload.multicurrencyPayments = formData.multicurrencyPayments
          ? formData.multicurrencyPayments
          : this.resData?.businessConfig?.multicurrencyPayments;
        payload.businessModel = formData.businessModel
          ? formData.businessModel
          : this.resData?.businessConfig?.businessModel;
        payload.businessAddress = formData.address
          ? formData.address
          : this.resData?.businessConfig?.address;
        payload.dateOfEstablishment = formData.dateOfEstablishment
          ? formData.dateOfEstablishment
          : this.resData?.businessConfig?.dateOfEstablishment;
        payload.cinNo = formData?.cinNo;
        payload.pancard = formData.pancard
          ? formData.pancard
          : this.resData?.businessConfig?.pancard;
        payload.pancardName = formData.pancardName
          ? formData.pancardName
          : this.resData?.businessConfig?.pancardName;
        payload.transactionsNo = formData.transactionsNo
          ? formData.transactionsNo
          : this.resData?.businessConfig?.pancardName;
        payload.gstNo = formData.gstNo
          ? formData.gstNo
          : this.resData?.businessConfig?.gstNo;
        payload.transactionsAmount = formData.transactionsAmount
          ? formData.transactionsAmount
          : this.resData?.businessConfig?.transactionsAmount;
        console.log(payload);
        if (this.customerBusinessDetailAndUploadForm.valid) {
          payload.validcustomerBusinessDetailAndUploadForm = true;
          this.customerService.sendCustomerFormData(payload);
          console.log('called');
        } else {
          payload.validcustomerBusinessDetailAndUploadForm = false;
          this.customerService.sendCustomerFormData(payload);
          this.customerBusinessDetailAndUploadForm.markAllAsTouched();
          console.log('called2');
        }
      });
    this.getAllScheme();
  }

  initForm() {
    this.customerBusinessDetailAndUploadForm = this.formBuilder.group({
      organisationType: ['', Validators.required],
      businessName: ['', Validators.required],
      website: ['', [Validators.required, Validators.pattern(this.urlPattern)]],
      multicurrencyPayments: ['', Validators.required],
      businessModel: ['', Validators.required],
      address: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      postalCode: ['', Validators.required],
      dateOfEstablishment: ['', Validators.required],
      cinNo: [
        '',
        [
         
          Validators.pattern(
            '^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$'
          ),
        ],
      ],
      pancard: [
        '',
        [Validators.required, Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]$')],
      ],
      pancardName: ['', Validators.required],
      transactionsNo: [
        '',
        [Validators.required],
      ],
      gstNo: [
        '',
        [
          Validators.required,
          Validators.pattern(
            '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[0-9A-Z]{1}[0-9A-Z]{1}$'
          ),
        ],
      ],
      transactionsAmount: ['', Validators.required],
      // SchemeManager: ['', ],
    });
  }

  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  patchCustomerBusinessDetailsData(data: any) {
    let pagination = {
      currentPage: 1,
      limit: 10000
    }
    console.log(data, data.businessConfig?.city?.cityId);
    if(data.businessConfig?.state?.stateId){
      this.cityService
      .getCityWithPagination(pagination,data.businessConfig?.state?.stateId)
      .subscribe((res: any) => {
        this.cityData = res.data.data;
        setTimeout(() => {
          this.customerBusinessDetailAndUploadForm.patchValue({
            city: data?.businessConfig?.city?.cityId
            ? data?.businessConfig?.city?.cityId
            : ''
          })
        },1000)
     
        console.log(this.cityData, this.customerBusinessDetailAndUploadForm.value)
      });
    }
   
    this.customerBusinessDetailAndUploadForm.patchValue({
      organisationType: data?.businessConfig?.organisationType
        ? data?.businessConfig?.organisationType
        : '',
      businessName: data.businessConfig?.businessName,
      website: data.businessConfig?.website,
      multicurrencyPayments: data.businessConfig?.multicurrencyPayments
        ? data.businessConfig?.multicurrencyPayments
        : '',
      businessModel: data.businessConfig?.businessModel,
      address: data.businessConfig?.address,
      state: data.businessConfig?.state?.stateId
        ? data.businessConfig?.state?.stateId
        : '',
      postalCode: data.businessConfig?.postalCode,
      dateOfEstablishment: data.businessConfig?.dateOfEstablishment,
      cinNo: data.businessConfig?.cinNo,
      pancard: data.businessConfig?.pancard,
      pancardName: data.businessConfig?.pancardName,
      transactionsNo: data.businessConfig?.transactionsNo,
      gstNo: data.businessConfig?.gstNo,
      transactionsAmount: data.businessConfig?.transactionsAmount,
      // SchemeManager: data.SchemeManager,
    });
    this.documents[0].file = data?.documents?.pan;
    this.documents[1].file = data?.documents?.aadhaar;
    this.documents[2].file = data?.documents?.photo;
    this.documents[3].file = data?.documents?.cin;
    this.docFiles.pan = data?.documents?.pan;
    this.docFiles.aadhaar = data?.documents?.aadhaar;
    this.docFiles.photo = data?.documents?.photo;
    this.docFiles.cin = data?.documents?.cin;
  }

  // if (data.documents?.length) {
  //   const updatedObjectArray = this.documents?.map((obj: any, index: any) => {
  //     return {
  //       ...obj,
  //       file: data?.documents[index],
  //     };
  //   });
  //   console.log(updatedObjectArray);
  //   this.documents = updatedObjectArray;
  // }

  ngOnDestroy(): void {
    this.customerDataObsSubscription?.unsubscribe();
    this.customerDataEventObsSubscription?.unsubscribe();
  }
  getAllScheme() {
    this.configuratorSchemeService.getAllSchemes().subscribe({
      next: (response: any) => {
        console.log('Get Scheme request ', response.data);
        this.schemes = response.data.filter((item: any) => {
          return item.userId == this.userId && item.status == 'active';
        });

        // console.log(this.schemes)
      },
      error: (error) => {
        console.error('Error  getting :', error);
      },
      complete: () => {
        console.log('Get request completed');
      },
    });
  }

  onCitySelect(ev: any) {
    let city = (this.selectedCity = this.cityData.find(
      (item: any) => item._id == ev.target.value
    ));
    this.selectedCity = {
      _id: city?._id,
      title: city?.title,
      cityId: city?.cityId,
    };
  }

  downloadFile(url: any) {
    window.open(url, '_blank');
  }

  getCityData() {
    let pagination = {
      currentPage: 1,
      limit: 10000,
    };
    this.cityService.getCityWithPagination(pagination).subscribe({
      next: (response) => {
        console.log('Create request ', response);
        this.cityData = response.data.data;
      },
      error: (error) => {
        console.error('Error  Creating state:', error);
      },
      complete: () => {
        console.log('Create request completed');
      },
    });
  }

  getStateData() {
    let pagination = {
      currentPage: 1,
      limit: 10000,
    };
    this.stateService.getStateWithPagination(pagination).subscribe({
      next: (response) => {
        console.log('Create request ', response);
        this.stateData = response.data.data;
      },
      error: (error) => {
        console.error('Error  Creating state:', error);
      },
      complete: () => {
        console.log('Create request completed');
      },
    });
  }

  onStateSelect(ev: any) {
    let pagination = {
      currentPage: 1,
      limit: 10000,
    };
    this.selectedState = this.stateData.find(
      (item: any) => item._id == ev.target.value
    );
    this.cityService
      .getCityWithPagination(pagination, this.selectedState._id)
      .subscribe((res: any) => {
        this.cityData = res.data.data;
      });
  }

  // onFileSelected(event: any, index: number) {
  //   console.log(event.target);
  //   this.selectedFiles = [...event.target.files];
  //   console.log(this.selectedFiles);
  //   if (this.selectedFiles?.length) {
  //     const updatedObjectArray = this.documents?.map((obj: any, index: any) => {
  //       return {
  //         ...obj,
  //         file: this?.selectedFiles[index],
  //       };
  //     });
  //     // for (let i = 0; i <= this.selectedFiles?.length; i++) {
  //     this.documents[index].file = URL.createObjectURL(this.selectedFiles[0]);
  //     // }
  //     this.selectedFiles[0]?.type != "image/png" ?  this.documents[index].name = this.selectedFiles[0]?.name
  //     : this.documents[index].name == '';
  //     console.log(updatedObjectArray);
  //     // this.documents = updatedObjectArray;
  //   }
  //   console.log(this.documents);
  // }

  onFileSelected(event: any, type: any) {
    console.log(event.target.files[0], type, this.documents);
    if (type == 'pan') {
      this.selectedFilesPan = event.target.files[0];
      console.log(event.target.files[0], type, this.documents);
      this.documents[0].file = URL.createObjectURL(this.selectedFilesPan);
      this?.selectedFilesPan.type.split('/')[0] != 'image'
        ? (this.documents[0].name = this?.selectedFilesPan?.name)
        : this.documents[0].name == '';
      this?.selectedFilesPan.type.split('/')[0] != 'image'
        ? (this.documents[0].file = '')
        : (this.documents[0].file = URL.createObjectURL(this.selectedFilesPan));
      this.uploadImgAPI(
        this.selectedFilesPan?.type,
        this.folderName,
        this.selectedFilesPan,
        'pan'
      );
      console.log(this.documents[0].file);
    }
    if (type == 'aadhaar') {
      this.selectedFileAadhaar = event.target.files[0];
      this.documents[1].file = URL.createObjectURL(this.selectedFileAadhaar);
      this?.selectedFileAadhaar.type.split('/')[0] != 'image'
        ? (this.documents[1].name = this?.selectedFileAadhaar?.name)
        : this.documents[1].name == '';
      this?.selectedFileAadhaar.type.split('/')[0] != 'image'
        ? (this.documents[1].file = '')
        : (this.documents[1].file = URL.createObjectURL(
            this.selectedFileAadhaar
          ));
      this.uploadImgAPI(
        this.selectedFileAadhaar?.type,
        this.folderName,
        this.selectedFileAadhaar,
        'aadhaar'
      );
    }
    if (type == 'photo') {
      this.selectedFilePhoto = event.target.files[0];
      this.documents[2].file = URL.createObjectURL(this.selectedFilePhoto);
      this?.selectedFilePhoto.type.split('/')[0] != 'image'
        ? (this.documents[2].name = this?.selectedFilePhoto?.name)
        : this.documents[2].name == '';
      this?.selectedFilePhoto.type.split('/')[0] != 'image'
        ? (this.documents[2].file = '')
        : (this.documents[2].file = URL.createObjectURL(
            this.selectedFilePhoto
          ));
      this.uploadImgAPI(
        this.selectedFilePhoto?.type,
        this.folderName,
        this.selectedFilePhoto,
        'photo'
      );
    }
    if (type == 'cin') {
      this.selectedFileCIN = event.target.files[0];
      this.documents[3].file = URL.createObjectURL(this.selectedFileCIN);
      this?.selectedFileCIN.type.split('/')[0] != 'image'
        ? (this.documents[3].name = this?.selectedFileCIN?.name)
        : this.documents[3].name == '';
      this?.selectedFileCIN.type.split('/')[0] != 'image'
        ? (this.documents[3].file = '')
        : (this.documents[3].file = URL.createObjectURL(this.selectedFileCIN));
      this.uploadImgAPI(
        this.selectedFileCIN?.type,
        this.folderName,
        this.selectedFileCIN,
        'cin'
      );
    }
    console.log(this.documents);
  }
  uploadImgAPI(filetype: any, folder_name: any, image: any, type: string) {
    this.portalBuilderServices
      .fileUpload(filetype, folder_name, image)
      .subscribe({
        next: (response: any) => {
          console.log('upload res ', response);
          if (type == 'pan') {
            this.docFiles.pan = response.data;
          }
          if (type == 'aadhaar') {
            this.docFiles.aadhaar = response.data;
          }
          if (type == 'photo') {
            this.docFiles.photo = response.data;
          }
          if (type == 'cin') {
            this.docFiles.cin = response.data;
          }
        },
        error: (error) => {
          console.error('Error  upload state:', error);
        },
        complete: () => {
          console.log('upload request completed');
          // clean-up logic for this
        },
      });
  }

  // console.log(
  //   'file format this.selectedFile ',
  //   this.selectedFileHlogo,
  //   this.selectedFileFlogo,
  //   this.selectedFileFavlogo
  // );

  // URL Pattern
  urlPattern =
    '^((https?|ftp|smtp):\\/\\/)?(www.)?[a-z0-9]+([\\-.]{1}[a-z0-9]+)*\\.[a-z]{2,5}' +
    '((\\/[\\w\\-]+)*\\/)?([\\w\\-]+\\.[\\w]{2,4}(\\?[\\w\\-]+=[\\w\\-]+)?)?$';
}
